import { Props_SnippetImageGallery } from './ImageGallery.props';
import { CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'


export const SnippetImageGallery = (props: Props_SnippetImageGallery) => {
    const { heading, image1, image2, image3, image4, image5 } = props;
    const titleClass = heading.visibility.value ? 'snippet-image-gallery__title' : 'snippet-image-gallery__title accessible-heading';

    return (
        <section className="snippet-image-gallery">
            <div className="snippet-image-gallery__container">
                <h2 className={titleClass}>{CompileHeadingToSpan(heading?.heading?.value|| '') }</h2>

                <div className="snippet-image-gallery__grid">
                    <figure className="snippet-image-gallery__image-container">
                        <img
                            loading="lazy"
                            src={image1?.src?.value}
                            alt={image1?.alt?.value}
                            className="snippet-image-gallery__image"
                            width="520"
                            height="620"
                        />
                    </figure>
                    {[image2, image3, image4, image5].map((image, index) => (
                        <figure key={index} className="snippet-image-gallery__image-container">
                            <img
                                loading="lazy"
                                src={image?.src?.value}
                                alt={image?.alt?.value}
                                className="snippet-image-gallery__image"
                                width="280"
                                height="300"
                            />
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SnippetImageGallery;